export default "__VITE_ASSET__BSzEvBjJ__"